import React, { useState } from 'react';
import { DialogTitle, IconButton, Grid, Stack, Button, Chip, Skeleton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import StopCircle from '@mui/icons-material/StopCircle';
import { useGetMachineUrlPdf } from 'hooks/useMachineHooks';
import { machineStatusColors } from 'utils/commonUtil';

export default function MachineHeader({ machineDetails, isLoadingMachine, handleClose, machinePermission, setOpenRejectModal, open }) {
  const [isDownloading, setIsDownloading] = useState(false);
  const isJobUrl = machineDetails?.apiKey !== null && machinePermission?.showMachineManual;

  const {
    data: jobUrl,
    isLoading: isLoadingPdfUrl,
    isFetching: isFetchingPDF
  } = useGetMachineUrlPdf({
    id: open.machineId,
    apikey: machineDetails?.apiKey,
    isJobUrl
  });

  const handleConfirmDownload = () => {
    setIsDownloading(true);
    setTimeout(() => {
      window.open(jobUrl, '_blank', 'noopener,noreferrer');
      setIsDownloading(false);
    }, 1500);
  };

  return (
    <>
      <DialogTitle variant="span" style={{ textTransform: 'capitalize', fontSize: '20px' }}>
        <Grid container spacing={0} sx={{ marginTop: '0px', padding: { xs: '10px 0 0 0', sm: '10px 0 0 0' } }}>
          <Grid item xs={12} sm={12} md={9} lg={9} xl={9} sx={{ wordWrap: 'break-word' }}>
            {isLoadingMachine ? (
              <Skeleton variant="rectangular" width={500} height={35} />
            ) : (
              `View Machine Details - ${machineDetails?.machineName}`
            )}
            {'  '}
            {machineDetails?.status && (
              <Chip
                label={machineDetails?.status}
                sx={{
                  borderRadius: '4px',
                  backgroundColor: machineStatusColors[machineDetails?.status],
                  color: '#fff',
                  fontWeight: '500'
                }}
              />
            )}
            {machinePermission?.stopService && (
              <Button
                disableElevation
                size="medium"
                variant="contained"
                color="error"
                onClick={() => setOpenRejectModal((prev) => ({ ...prev, open: true, id: open.machineId }))}
                startIcon={<StopCircle />}
                sx={{ backgroundColor: '#f44336', '&:hover': { backgroundColor: '#d32f2f' }, width: '145px', marginLeft: '15px' }}
              >
                Stop Service
              </Button>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            {machineDetails?.apiKey !== null && machinePermission?.showMachineManual && (
              <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ padding: { xs: '10px 28px 0 0', md: '0 28px 0 0' } }}>
                <Button
                  sx={{
                    color: '#fff'
                  }}
                  disableElevation
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmDownload}
                  disabled={isLoadingPdfUrl || isFetchingPDF || isDownloading}
                >
                  {isLoadingPdfUrl || isFetchingPDF || isDownloading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <SimCardDownloadIcon sx={{ color: '#fff' }} />
                  )}
                  {isLoadingPdfUrl || isFetchingPDF || isDownloading ? `  Generating Manual` : ` Machine Manual`}
                </Button>
              </Stack>
            )}
          </Grid>
        </Grid>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({ position: 'absolute', right: 8, top: 8, color: theme.palette.grey[500] })}
      >
        <CloseIcon color="error" />
      </IconButton>
    </>
  );
}
